import { render, staticRenderFns } from "./Winery.vue?vue&type=template&id=5043dfb2&scoped=true"
import script from "./Winery.vue?vue&type=script&lang=js"
export * from "./Winery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5043dfb2",
  null
  
)

export default component.exports